export const selectCurrentUser = (state) => {
  return state.get('currentUser');
};

export const selectUserRole = (state) => {
  return state.get('userRole');
};

export const selectAllowedSpecIds = (state) => {
  return state.get('allowedSpecIds') || [];
};

export const selectUserEnvironment = (state) => {
  return state.get('userEnvironment');
};

export const selectAuthLoading = (state) => {
  return state.get('authLoading') || false;
};

export const selectAuthError = (state) => {
  return state.get('authError');
};

export const selectIsAdmin = (state) => {
  return state.get('userRole') === 'MOCKORCHESTRATOR_ADMIN';
};

export const selectIsEditor = (state) => {
  const role = state.get('userRole');
  return role === 'MOCKORCHESTRATOR_EDITOR' || role === 'MOCKORCHESTRATOR_ADMIN';
};

export const selectIsViewer = (state) => {
  return state.get('userRole') === 'MOCKORCHESTRATOR_VIEWER';
};

export const selectIsViewerEnv = (state) => {
  return state.get('userRole') === 'MOCKORCHESTRATOR_VIEWER_ENV';
};

export const selectIsViewerOrViewerEnv = (state) => {
  const role = state.get('userRole');
  return role === 'MOCKORCHESTRATOR_VIEWER' || role === 'MOCKORCHESTRATOR_VIEWER_ENV';
};

export const selectDefaultSpecId = (state) => {
  return state.get('defaultSpecId');
};
